import React from 'react';
import {
	OldTicketsTitleWrapper,
	OldTicketsTitle,
} from '../../TicketView.styled';
import OldTicketsList from '../../../oldTicketsList/OldTicketsList';

const OldTickets = ({
	oldTickets,
	selectedTicket,
	handleSelectTicket,
	departments,
}) => {
	return (
		<>
			<OldTicketsTitleWrapper>
				<OldTicketsTitle>Old tickets</OldTicketsTitle>
			</OldTicketsTitleWrapper>
			<OldTicketsList
				oldTickets={oldTickets}
				selectedTicket={selectedTicket}
				handleSelectTicket={handleSelectTicket}
				departments={departments}
			/>
		</>
	);
};

export default OldTickets;
